module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Compiled-file-436feb2ec2bb3e45ca94837115f16081.svg";